export const Panels = {
  InventoryInstance: 'InventoryInstance',
  InventoryMultiInstance: 'InventoryMultiInstance',
  BackupJobsCard: 'BackupJobsCard',
  RestoreJobsCard: 'RestoreJobsCard',
  FileSearchInstance: 'FileSearchInstance',
  RestoreVolumeWizard: 'RestoreVolumeWizard',
  RestoreEc2InstanceWizard: 'RestoreEc2InstanceWizard',
  RestoreFileWizard: 'RestoreFileWizard',
  RestoreRDSWizard: 'RestoreRDSWizard',
  RestoreDynamoWizard: 'RestoreDynamoWizard',
  RestoreS3Wizard: 'RestoreS3Wizard',
  RestoreMongoAtlasWizard: 'RestoreMongoAtlasWizard',
  RestoreAzureVMWizard: 'RestoreAzureVMWizard',
  RestoreAzureDiskWizard: 'RestoreAzureDiskWizard',
  RestoreEksNamespaceWizard: 'RestoreEksNamespaceWizard',
  RestoreAzureSqlDBWizard: 'RestoreAzureSqlDBWizard',
  EditBackupVault: 'EditBackupVault',
  BackupPolicy: 'BackupPolicy',
  CustomRole: 'CustomRole',
  ApiCredentials: 'ApiCredentials',
  NotificationPolicy: 'NotificationPolicy',
  SAML: 'SAML',
  Filters: 'Filters',
  Control: 'Control',
  CloudAccount: 'CloudAccount',
  UpsertUser: 'UpsertUser',
  UpsertGroupMapping: 'UpsertGroupMapping',
  ConvertToAMIWizard: 'ConvertToAMIWizard',
  RestoreAccountConfig: 'RestoreAccountConfig',
  ConvertToMultipleEonSnapshots: 'ConvertToMultipleEonSnapshots',
  ConvertToSingleEonSnapshot: 'ConvertToSingleEonSnapshot',
  ObjectStoreBackupConfiguration: 'ObjectStoreBackupConfiguration',
  RestoreGcpVMWizard: 'RestoreGcpVMWizard',
  RestoreGcpDiskWizard: 'RestoreGcpDiskWizard',
  RestoreGcpCloudSqlWizard: 'RestoreGcpCloudSqlWizard',
  UpdateAccountAWSPanel: 'UpdateAccountAWSPanel',
  RansomwareConditionPanel: 'RansomwareByConditionPanel',
  BackupScopeResourcesWizard: 'BackupScopeResourcesWizard',
} as const;

export type Panels = (typeof Panels)[keyof typeof Panels];
